<template>
  <v-dialog
      fullscreen
      eager
      scrollable
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <LoadingDialog ref="loading"
      :loader-msg="$t('book/facility:facility.dashboard.information.state.generate-wait-gbu-report')"/>

    <v-card elevation="0">
      <div class="text-right px-4 mt-4">
        <v-btn icon @click="cancelDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </div>
      <v-card-text>
        <div ref="top"></div>
        <v-form ref="form">
          <h3 class="font-weight-bold px-sm-5 mb-0">Erstelle Befund zur Gefahrenüberprüfung</h3>
          <div v-if="!data">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-else>

            <v-checkbox color="primary" v-model="useCostEstimate"
                        label="Kostenabschätzung hinzufügen" />

            <div v-if="data.length === 0" >
              <p class="mt-2 mb-6 font-weight-bold">Es wurden keinerlei Gefahren bei der Gefahrenüberprüfung festgestellt.</p>
            </div>
            <div v-for="chapter in data" :key="chapter.nr+chapter.title">
              <h4 class="primary--text font-weight-medium mt-3">{{chapter.nr + ' ' +chapter.title }}</h4>
              <div v-for="check in chapter.checks" :key="check.nr">
                <h5>{{check.nr}} {{check.check}}</h5>
                <p>Risiko: {{check.risk}}</p>
                <div :class="getProtectionsContainerClass(check)">
                  <div v-for="protection in check.protections" :key="protection.nr"  class="ml-3">
                  <v-checkbox color="primary" v-model="protection.use"
                              :label="protection.userText ? protection.userText : protection.text " />
                  <v-textarea
                      v-if="protection.userText && protection.use"
                      color="primary"
                      outlined
                      v-model="protection.text"
                      label="Schutzmaßnahme"
                      validate-on-blur
                      :rules="[ruleRequired($t('utils:rules.required'))]"
                  />
                  <div v-if='protection.use && useCostEstimate' class="horizontal">
                    <v-text-field
                        color="primary"
                        type="number"
                        outlined
                        :full-width="false"
                        class="width200"
                        v-model.number="protection.cost"
                        label="Kosten"
                        validate-on-blur
                        :rules="[ruleIsInteger($t('utils:rules.onlynumerictext'))]"
                        @keydown="onKeyDown($event)"
                    />

                    <v-checkbox class="ml-1" color="primary" v-model="protection.usePriceInSum"
                                label="verwende Preis für Gesamtsumme" />

                  </div>
                </div>

                </div>
                <p class="mb-3 error--text v-messages">{{ showError(check) ? 'Mindestens eine Schutzmaßnahme muss ausgewählt sein': '' }}</p>
              </div>
            </div>
          </div>
          <BaseButton
              color="primary"
              btnText="Erzeuge Befund"
              @clickedButton="generateReport()"
          />
          <BaseButton
              :btn-text="$t('buttons:cancel')"
              color="grey"
              @clickedButton="cancelDialog"
          />
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<script>

import BaseButton from "@/modules/core/components/Base/BaseButton.vue";
import { ruleIsInteger, ruleRequired } from "@/modules/core/services/rules";
import PdfUtils from "@/modules/core/services/pdf-utils";
import Utils from "@/modules/core/services/utils";
import GbuResultService from "@/modules/book/services/gbu-result-service";
import LoadingDialog from "@/modules/core/components/Loader/LoadingDialog.vue";
export default {
  name: "FacilityGbuReportDialogForm.vue",
  components: {
    BaseButton,
    LoadingDialog,
  },
  data() {
    return {
      dialog: false,
      useCostEstimate: false,
      data: null,
      showValidation: false,
      gbuId: null,
      protVersion: null,
    }
  },
  methods: {
    cancelDialog() {
      this.dialog = false;
    },

    openDialog(gbu, withCostEstimate, oldProtections) {
      this.dialog = true;
      this.useCostEstimate = withCostEstimate;
      this.gbuId = gbu.id;
      this.data = [];
      const protections = JSON.parse(this.getProtectionJson());
      this.protVersion = protections.protVersion;

      const gbuProt = protections.gbuProtections;
      this.getProtectionFields(gbuProt, gbu.chapters);
      const scProtections = protections.scProtections;
      this.getProtectionFields(scProtections, gbu.surroundingsChapters);

      for (const chapter of this.data){
        for (const check of chapter.checks) {
          if (check.protections.length === 1) {
            check.protections[0].use = true;
          }
        }
      }

      if (oldProtections) {
        // console.log(JSON.stringify(oldProtections, null, 2)); // debug info stored protections
        if (oldProtections.protVersion === this.protVersion) {
          let protIndex = 0;
          let oldProt = oldProtections.protections;
          for (const chapter of this.data) {
            for (const check of chapter.checks) {
              for (const prot of check.protections) {
                if (protIndex >= oldProt.length) {
                  break;
                }
                let oldValue = oldProt[protIndex];
                if (prot.nr === oldValue.nr) {
                  prot.use = true;
                  prot.text = oldValue.text;
                  if (oldProtections.hasCostEstimate) {
                    prot.cost = oldValue.cost;
                    prot.usePriceInSum = oldValue.incSum;
                  }
                  protIndex++;
                }
              }
            }
          }
        }
      }
      // console.log( JSON.stringify(this.data, null, 2)); // debug info edit-data
    },

    getProtectionFields(gbuProt, chapters ) {
      let protIndex = 0;
      let currentChapter = null;
      let currentCheck = null;

      for (const chapter of chapters) {
        let nrRisks = chapter.countHighRisk + chapter.countMediumRisk + chapter.countLowRisk;
        if (nrRisks > 0) {
          for (const check of chapter.checks) {
            if (check.isRisk !== 'ja') { // 'nein' or 'nicht zutreffend'
              continue;
            }
            if (this.data.length === 0 || this.data[this.data.length -1].title !== chapter.title) {
              // add new chapter
              const dataChapter = {nr: chapter.nr, title: chapter.title, checks:[] };
              this.data.push(dataChapter);
              currentChapter = dataChapter;
            }
            let checkNr = check.nr;
            // search for associated protections for check beginning with same checkNr 
            while(gbuProt.length > protIndex && gbuProt[protIndex].nr.substring(0, checkNr.length) !== checkNr) {
              protIndex++;
            }
            // iterate through all matching protections for current check
            while(gbuProt.length > protIndex && gbuProt[protIndex].nr.substring(0, checkNr.length) === checkNr) {
              let checkArray = currentChapter.checks;
              if (checkArray.length === 0 || checkArray[checkArray.length-1].nr !== checkNr ) {
                // add new check
                const dataCheck = { nr:check.nr, check:check.check, protections:[], risk:check.risk }
                currentChapter.checks.push(dataCheck);  
                currentCheck = dataCheck;
              }
              const currentProt = gbuProt[protIndex];
              let prot = { nr:currentProt.nr, text:currentProt.text, use:false, cost:null, usePriceInSum:true };
              if (prot.text === ''){
                prot.userText = 'Schutzmaßnahme eingeben:';
              }
              currentCheck.protections.push(prot);
              // console.log(checkNr + " " + gbuProt[protIndex].nr + " " + gbuProt[protIndex].text); // debug info matching check with protection
              protIndex++;
            }
            // additional user input for another user-defined Protection
            if (currentCheck !== null) {
              let prot = { nr:currentCheck.nr+".user", text:'', use:false, cost:null, usePriceInSum:true,
                            userText: 'Andere Schutzmaßnahme:'};
              currentCheck.protections.push(prot);
            }
          }
        }
      }
    },

    onKeyDown(event) {
      const allowedKeys= ['0','1','2','3','4','5','6','7','8','9',
        'Backspace', 'Delete', 'Tab', 'Enter',
        'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
      if (allowedKeys.indexOf(event.key) >= 0) {
        return false;
      }
      return event.preventDefault();  // ignore all other keys
    },
    generateReport() {
      // console.log( JSON.stringify(this.data, null, 2)); // debug info edit-data
      this.showValidation = true;
      let isValid= this.$refs.form.validate();  //validates cost- and text input
      // check if at least one protection is set per check-point
      if (isValid) {
        for (let chapter of this.data) {
          if (!isValid) {
            break;
          }
          for (let check of chapter.checks) {
            let hasProtection = this.hasProtectionSet(check);
            if (!hasProtection) {
              isValid = false;
              break;
            }
          }
        }
      }
      if (!isValid) {
        this.$refs.top.scrollIntoView({behavior:'smooth'})
        return;
      }
      else {
        // debug
        this.$refs.loading.openDialog();
        let selectedProtections = this.generateSelectedProtections();
        // console.log(JSON.stringify(selectedProtections, null, 2)); // debug info selected protections to be stored in db
        GbuResultService.updateGbuAndGenerateReport(this.gbuId, JSON.stringify(selectedProtections),
            (result) => {
              this.$refs.loading.closeDialog();
              PdfUtils.openPDFInNewTabSetFileType(result.data);
              this.$emit("update-gbu",this.gbuId);
              this.cancelDialog();
            },
            (error) => {
              this.$refs.loading.closeDialog();
              this.$logger.error("ProcessResult could not be updated and report not being generated, because: " + error);
              Utils.showFailureSnackbar(this.$t("book/process:overview.report-gen-failed"));
            }
        );
      }
    },

    generateSelectedProtections() {
      let selectedProtections = {
        protVersion: this.protVersion,
        hasCostEstimate: this.useCostEstimate,
        protections: [],
      }
      for (let chapter of this.data) {
        for (let check of chapter.checks) {
          for (let prot of check.protections) {
            if (prot.use) {
              let newProt = { nr: prot.nr, text: prot.text};
              if (this.useCostEstimate) {
                newProt.cost = +prot.cost;
                newProt.incSum= prot.usePriceInSum === true;
              }
              selectedProtections.protections.push(newProt);
            }
          }
        }
      }
      return selectedProtections;
    },

    getProtectionsContainerClass(check) {
      return this.showError(check) ? "error-border" : "border";
    },

    showError(check) {
      if (!this.showValidation) {
        return false;
      }
      return !this.hasProtectionSet(check);
    },

    hasProtectionSet(check) {
      for (let prot of check.protections) {
        if (prot.use) {
          return true;
        }
      }
      return false;
    },


    ruleIsInteger,
    ruleRequired,

    getProtectionJson() {
      return `{
  "formVersion": 1,
  "protVersion": 1,
  "gbuProtections": [
    {
      "nr": "1.1.a",
      "text": "Maßnahmen in Übereinstimmung mit  CEN / TS 81-83"
    },
    {
      "nr": "1.2.a",
      "text": "Maßnahmen in Übereinstimmung mit EN81-73"
    },
    {
      "nr": "1.3.a",
      "text": "Maßnahmen in Übereinstimmung mit EN81-77"
    },
    {
      "nr": "1.4.a",
      "text": "Bauteile sind frei von schädlichen Stoffen, z.B. Asbest siehe EN81-20: 0.4.3 e \\na) entfernen von zerfallenen Asbest (z.B. Ersatz des Bremsbelag Materials)"
    },
    {
      "nr": "1.4.b",
      "text": "b)  Keine Arbeiten an Asbest ausführen ==> Warnschild anbringen"
    },
    {
      "nr": "2.1.a",
      "text": "Vorsehen einer / mehrerer Schließeinrichtung (en) nach EN81-20:  5.2.3.3 b) und c)"
    },
    {
      "nr": "2.2.a",
      "text": "Einbau einer elektrischen Sicherheitseinrichtung nach EN81-20:  5.2.3.3 d)"
    },
    {
      "nr": "2.3.a",
      "text": "a) Einbau einer vollwandigen Schachtumwehrung nach EN81-20:  5.2.5.2.2.1, oder"
    },
    {
      "nr": "2.3.b",
      "text": "b) falls gerechtfertigt, Einbau einer durchbrochenen Schachtumwehrung nach EN81-21: 5.2"
    },
    {
      "nr": "2.4.a",
      "text": "a) Einbau einer vollwandigen Schacht Umwehrung oder"
    },
    {
      "nr": "2.4.b",
      "text": "b) Vorsehen eines Schutzes um die Schachttürverriegelung nach EN81-21: 5.2 b"
    },
    {
      "nr": "2.5.a",
      "text": "a) Einbau einer vollwandigen Schachtumwehrung nach EN81-20: 5.2.5.2.2.1, oder"
    },
    {
      "nr": "2.5.b",
      "text": "b) falls gerechtfertigt, Einbau einer durchbrochenen Schachtumwehrung nach EN81-20: 5.2.5.2.3"
    },
    {
      "nr": "2.6.a",
      "text": "Vorsehen geeigneter Mittel nach EN81-20: 5.2.5.3.2, unter jeder Türschwelle"
    },
    {
      "nr": "2.7.a",
      "text": "Einbau einer Fangvorrichtung für das Gegen- oder Ausgleichsgewicht (sicherstellen der Bodentragfähigkeit von 5kg/n³ pro m²) nach EN81-20: 5.2.5.4"
    },
    {
      "nr": "2.8.a",
      "text": "Einbau einer Gegengewichts- / Ausgleichsgewichts-abtrennung  nach EN81-20: 5.2.5.5.1"
    },
    {
      "nr": "2.9.a",
      "text": "Einbau einer Abtrennung in der Schachtgrube nach EN81-20: 5.2.5.5.2"
    },
    {
      "nr": "2.10.a",
      "text": "Einbau einer Abtrennung bis zur vollen Schachthöhe nach EN81-20: 5.2.5.5.2"
    },
    {
      "nr": "2.11.a",
      "text": "a) Einbau von Schutzräumen und Freiräumen nach EN81-20: 5.2.5.7"
    },
    {
      "nr": "2.11.b",
      "text": "b) Vorsehen technischer Maßnahmen zur Schaffung von Schutzräumen und Freiräumen nach EN81-21: 5.5"
    },
    {
      "nr": "2.11.c",
      "text": "c) Kennzeichnung der Schutzräume"
    },
    {
      "nr": "2.12.a",
      "text": "a) Einbau von Schutzräumen und Freiräumen in der Schachtgrube nach EN81-20: 5.2.5.8"
    },
    {
      "nr": "2.12.b",
      "text": "b) Vorsehen technischer Maßnahmen zur Schaffung von Schutzräumen und Freiräumen nach EN81-21: 5.7"
    },
    {
      "nr": "2.12.c",
      "text": "c) Kennzeichnung der Schutzräume"
    },
    {
      "nr": "2.13.a",
      "text": "Vorsehen von Maßnahmen für den Zugang zur Schachtgrube nach EN81-20: 5.2.2.4"
    },
    {
      "nr": "2.14.a",
      "text": "Einbau einer Schachtbeleuchtung nach EN81-20: 5.2.1.4.1"
    },
    {
      "nr": "2.15.a",
      "text": "Einbau eines Notbremsschalters nach EN81-20: 5.2.1.5.1 a)"
    },
    {
      "nr": "2.16.a",
      "text": "Sind keine Fluchtmittel für in den Schacht eingeschlossener Personen vorgesehen, sind eine oder mehrere Notrufauslöseeinrichtungen nach EN81-20: 5.2.1.6 vorzusehen"
    },
    {
      "nr": "2.17.a",
      "text": "a) Vorsehen von Maßnahmen zur Verringerung des Abstands nach EN81-20: 5.2.5.3.1 oder"
    },
    {
      "nr": "2.17.b",
      "text": "b) Einbau vor Verriegelungen an der Fahrkorbtür nach EN81-20: 5.3.9.2"
    },
    {
      "nr": "2.18.a",
      "text": "Personen müssen daran gehindert werden, sich zwischen der geschlossenen Fahrkorbtür und der Schachttür nach EN81-20: 5.3.4.3, aufzuhalten"
    },
    {
      "nr": "2.19.a",
      "text": "Personen müssen daran gehindert werden, zwischen der geschlossenen Fahrkorbtür und der Schachttür nach EN81-20: 5.3.4.2, zu betreten"
    },
    {
      "nr": "3.1.a",
      "text": "Vorsehen von Maßnahmen für den sicheren Zugang Aufstellungsorten von Triebwerks- und Rollenraum nach EN81-20: 5.2.2.5"
    },
    {
      "nr": "3.2.a",
      "text": "Einbau einer elektrischen Beleuchtung nach EN81-20: 5.2.1.4.2"
    },
    {
      "nr": "3.3.a",
      "text": "Einbau von Notbremsschaltern nach EN81-20: 5.2.1.5.2 c)"
    },
    {
      "nr": "3.4.a",
      "text": "a) Prüfen und Anzeigen der sicheren Betriebslast bestehender Einrichtungen oder"
    },
    {
      "nr": "3.4.b",
      "text": "b) Einbau von Aufhängepunkten mit Angabe der sicheren Betriebslast nach EN81-20: 5.2.1.7"
    },
    {
      "nr": "3.5.a",
      "text": "Einbau von rutschhemmendem Boden nach EN81-20: 5.2.1.9"
    },
    {
      "nr": "3.6.a",
      "text": "a) Sicherstellen horizontaler und vertikaler Freiräume nach EN81-20: 5.2.6.3.2.1 a) und b), 5.2.6.3.2.2, 5.2.6.3.2.3, 5.2.6.4.2.1 a) und b) 5.2.6.4.2.2 oder"
    },
    {
      "nr": "3.6.b",
      "text": "b) falls horizontale oder vertikale Freiräume fehlen, Sicherung beweglicher Teile durch Abtrennungen nach EN ISO 13857:2018, 4.2.4.1"
    },
    {
      "nr": "3.7.a",
      "text": "Einbau einer Einrichtung nach EN81-20: 5.2.6.3.2.4, 5.2.6.3.2.5"
    },
    {
      "nr": "3.8.a",
      "text": "Einbau einer Gegensprechanlage oder einer ähnlichen Einrichtung nach EN81-20: 5.12.3.2"
    },
    {
      "nr": "4.1.a",
      "text": "Einbau von vollwandigen Schachttüren nach EN81-20: 5.3.1.2"
    },
    {
      "nr": "4.2.a",
      "text": "Einbau von vollwandigen Fahrkorbtüren nach EN81-20: 5.3.1.2"
    },
    {
      "nr": "4.3.a",
      "text": "Einbau von Schachttüren nach EN81-20: 5.3.5.3"
    },
    {
      "nr": "4.4.a",
      "text": "Einbau von Fahrkorbtüren nach EN81-20: 5.3.5.3"
    },
    {
      "nr": "4.5.a",
      "text": "Einbau von Schachttüren mit Glas nach EN81-20: 5.3.5.3.4, 5.3.5.3.5, 5.3.5.3.6, 5.3,5.3.7"
    },
    {
      "nr": "4.6.a",
      "text": "Einbau von Schachttüren mit Glas nach EN81-20: 5.3.5.3.4, 5.3.5.3.5, 5.3.5.3.6, 5.3,5.3.7"
    },
    {
      "nr": "4.7.a",
      "text": "a) reduzieren der Größe von Schauöffnungen und Ersetzen durch Verbundsicherheitsglas nach EN81:20: 5.3.7.2.1 a) oder"
    },
    {
      "nr": "4.7.b",
      "text": "b) Ersatz durch einen festen Einsatz sowie Anbringen einer Fahrkorbanwesenheitsanzeige  nach EN81-20: 5.3.7.2.1 b)"
    },
    {
      "nr": "4.8.a",
      "text": "Reduzierende Größe von Schauöffnungen und Ersetzen durch Verbundsicherheitsglas nach EN81-20: 5.3.7.2.1 a)"
    },
    {
      "nr": "4.9.a",
      "text": "Einbau von Einrichtungen nach EN81-20: 5.3.6.2.2.1 b)"
    },
    {
      "nr": "4.10.a",
      "text": "Einbau von Einrichtungen nach EN81-20: 5.3.6.2.2.1 c) und d)"
    },
    {
      "nr": "4.11.a",
      "text": "Einbau von Einrichtungen nach EN81-20: 5.3.6.2.2.1 c)"
    },
    {
      "nr": "4.12.a",
      "text": "Einbau von Schutzeinrichtungen gegen das Einziehen von Kinderhänden nach EN81-20: 5.3.6.2.2.1 h) und i)"
    },
    {
      "nr": "4.13.a",
      "text": "Einbau von Beleuchtungen an jedem Schachtzugang nach EN81-20: 5.3.7.1"
    },
    {
      "nr": "4.14.a",
      "text": "Einbau Schachttürverriegelungen nach EN81-20: 5.3.9.1"
    },
    {
      "nr": "4.15.a",
      "text": "Einbau Notentriegelungsdreikant nach EN81-20: 5.3.9.3.1"
    },
    {
      "nr": "4.16.a",
      "text": "Einbau Schließeinrichtung nach EN81-20: 5.3.9.3.4"
    },
    {
      "nr": "4.17.a",
      "text": "Einbau einer Einrichtung nach EN81-20: 5.3.11"
    },
    {
      "nr": "4.18.a",
      "text": "Einbau von Schachttüren nach EN81-58 sowie DIN 18091 wenn die bestehenden Schachttüren nicht die Anforderungen der vorherigen nationalen Brandschutzvorschriften erfüllen"
    },
    {
      "nr": "4.19.a",
      "text": "a) Sicherstellen, dass die Schachttür erst entriegelt wird, bis die Fahrkorbtür vollständig geöffnet ist, und"
    },
    {
      "nr": "4.19.b",
      "text": "b) Sicherstellen, dass die Fahrkorbtür erst dann zu schließen beginnt, wenn die Schachttür geschlossen ist."
    },
    {
      "nr": "4.20.a",
      "text": "a) Einbau von automatisch betriebenen Fahrkorbtüren nach EN81-20: 5.3.6.2.2.1, oder"
    },
    {
      "nr": "4.20.b",
      "text": "b) Einbau von nicht automatisch betriebenen Fahrkorbtüren nach EN81-20: 5.3.6.2.2.2"
    },
    {
      "nr": "4.21.a",
      "text": "a) Einbau einer Einrichtung an einer Fahrkorbtür nach EN81-20: 5.3.15.2, oder"
    },
    {
      "nr": "4.21.b",
      "text": "b) Einbau einer Fahrkorbtürverriegelung nach EN81-20: 5.3.9.2"
    },
    {
      "nr": "5.1.a",
      "text": "a) Abstimmen des Verhältnisses zwischen der Grundfläche des Fahrkorbs und der Nutzlast nach  EN81-20: 5.4.2 oder"
    },
    {
      "nr": "5.2.a",
      "text": "a) Einbau einer Fahrkorbschürze nach EN81-20: 5.4.5 oder"
    },
    {
      "nr": "5.2.b",
      "text": "b) Einbau einer Schürze nach EN81-21: 5.8"
    },
    {
      "nr": "5.3.a",
      "text": "Einbau einer Verriegelung der Notklappe nach EN81-20: 5.4.6.3"
    },
    {
      "nr": "5.4.a",
      "text": "Verstärkung des Fahrkorbdachs und der Notklappe nach EN81-20: 5.4.7.1 a)"
    },
    {
      "nr": "5.5.a",
      "text": "a) Verringerung der freien Abstände zwischen dem äußeren Rand des Fahrkorbdachs und angrenzenden Wänden und bis zur vollen Höhe auf 0,30 m oder"
    },
    {
      "nr": "5.5.b",
      "text": "b) Einbau einer Umwehrung auf dem Fahrkorbdach (höhe 0,7m bei Abstand 0,5m, höhe 1,1m bei Abstand über 0,5m) nach EN81-20: 5.4.7.4. oder"
    },
    {
      "nr": "5.5.c",
      "text": "c) Einbau einer Umwehrung auf dem Fahrkorbdach nach EN81-21: 5.6"
    },
    {
      "nr": "5.6.a",
      "text": "Versehen einer Fahrkorbbelüftung nach EN81-20: 5.4.9"
    },
    {
      "nr": "5.7.a",
      "text": "Einbau einer Beleuchtung nach EN81-20: 5.4.10.1; 5.4.10.2; 5.4.10.3"
    },
    {
      "nr": "5.8.a",
      "text": "Einbau einer Notbeleuchtung im Fahrkorb nach  EN81-20: 5.4.10.4"
    },
    {
      "nr": "5.9.a",
      "text": "Einbau einer Notbeleuchtung auf dem Fahrkorb nach EN81-20: 5.4.10.4"
    },
    {
      "nr": "5.10.a",
      "text": "Einbau einer Kontrolle der Beladung nach EN81-20: 5.12.1.2"
    },
    {
      "nr": "5.11.a",
      "text": "Einbau einer Fernnotrufeinrichtung nach EN81-28"
    },
    {
      "nr": "6.1.a",
      "text": "Einbau eines Schutzes gegen Verletzungen an Treibscheiben, Seilrollen oder Kettenrädern nach EN81-20: 5.5.7"
    },
    {
      "nr": "6.2.a",
      "text": "Einbau eines Schutzes gegen das Herausspringen von Seilen / Ketten und Treibscheibe oder Kettenrädern nach EN81-20: 5.5.7"
    },
    {
      "nr": "6.3.a",
      "text": "Einbau eines Schutzes gegen das Eindringen von Fremdkörpern zwischen Seilen / Ketten aus der Treibscheibe, Rollen oder Kettenrädern nach EN81-20: 5.5.7"
    },
    {
      "nr": "6.4.a",
      "text": "a) Prüfen, ob alle bestehenden Komponenten für den Schutz gegen freien Fall und Abwärtsbewegungen mit überhöhter Geschwindigkeit angemessen und kompatibel sind oder, wenn nicht,"
    },
    {
      "nr": "6.4.b",
      "text": "b) Einbau eines Schutzes gegen freien Fall und Abwärtsbewegungen mit überhöhter Geschwindigkeit nach EN81-20: Tabelle 11 oder Tabelle 12 (Bremsfang; Sperfang v<0,63m/s bzw. <1,0m/s mit Dämpfung; Leitungsbruchventil; Drossel)"
    },
    {
      "nr": "6.5.a",
      "text": "Einbau eines geeigneten Schutzes gegen unkontrollierte Aufwärtsbewegungen nach EN81-20: 5.6.6"
    },
    {
      "nr": "6.6.a",
      "text": "Einbau von Schutzmaßnahmen gegen unbeabsichtigte Bewegungen nach EN 8-20: 5.6.7"
    },
    {
      "nr": "6.7.a",
      "text": "Vorsehen von Schutzmaßnahmen gegen Absinken nach EN81-20: Tabelle 12"
    },
    {
      "nr": "6.8.a",
      "text": "Einbau einer elektrischen Sicherheitseinrichtung nach EN81-20: 5.6.2.2.1.6 c)"
    },
    {
      "nr": "6.9.a",
      "text": "Einbau einer Sicherheitseinrichtung gegen Schlaffseil -/- kette nach EN81-20: 5.5.5.3"
    },
    {
      "nr": "7.1.a",
      "text": "a) Einbau von festen Führungsschienen nach EN81-20: 5.7 oder"
    },
    {
      "nr": "7.1.b",
      "text": "b) Einbau von Führungen nach EN81-21: 5.4.3"
    },
    {
      "nr": "7.2.a",
      "text": "Einbau von Puffern nach EN81-20: 5.8"
    },
    {
      "nr": "7.3.a",
      "text": "Einbau eines Sicherheitsschalters nach EN81-20: 5.8"
    },
    {
      "nr": "8.1.a",
      "text": "Einbau von Bremsen nach EN-20: 5.9.2.2.2"
    },
    {
      "nr": "8.2.a",
      "text": "a) Einbau eines Notbetriebssystems für Seilaufzüge und Kettenaufzüge nach  EN81-20: 5.9.2.3 oder"
    },
    {
      "nr": "8.2.b",
      "text": "b) Hydraulikaufzüge nach EN81-20: 5.9.3.9 und"
    },
    {
      "nr": "8.2.c",
      "text": "c) Bereitstellen von Betriebsanweisungen nach EN81-20: 7.2.2"
    },
    {
      "nr": "8.3.a",
      "text": "Einbau von unabhängigen Schalteinrichtungen nach EN81-20: 5.9.2.7 oder 5.9.3.10"
    },
    {
      "nr": "8.4.a",
      "text": "Einbau einer Laufzeitüberwachung nach EN81-20: 5.9.2 bzw. 5.9.3"
    },
    {
      "nr": "8.5.a",
      "text": "Einbau eines Absperrventils nach EN81-20: 5.9.3.5.1"
    },
    {
      "nr": "8.6.a",
      "text": "Einbau einer Kolbenbabsinkvorrichtung unter Berücksichtigung von EN81-20: 5.9.3.9.1.5"
    },
    {
      "nr": "9.1.a",
      "text": "Einbau eines Schutzes gegen direktes Berühren nach  EN81-20: 5.10.1.2.2"
    },
    {
      "nr": "9.2.a",
      "text": "Anbringen von Kennzeichnungen an elektrischen Einrichtungen nach EN81-20: 5.10.6.3.5"
    },
    {
      "nr": "9.3.a",
      "text": "Einbau eines Schutzes gegen Überhitzung des Aufzugsmaschinenmotors nach EN81-20: 5.10.4"
    },
    {
      "nr": "9.4.a",
      "text": "Einbau abschließbarer Hauptschalter nach EN81-20: 5.10.5"
    },
    {
      "nr": "9.5.a",
      "text": "Einbau einer Einrichtung nach EN81-20: 5.12.1.11.1"
    },
    {
      "nr": "10.1.a",
      "text": "Einbau von Erdfehlerschutz (FI Schutzschalter) nach EN81-20: 5.11.1.4"
    },
    {
      "nr": "10.2.a",
      "text": "Einbau eines Phasenumkehrumkehrschutzes nach EN81-20: 5.11.1.2 j), um sicherzustellen, dass eine Phasenumkehr der Hauptstromversorgung keine gefährliche Fehlfunktion eines Aufzugs verursachen kann"
    },
    {
      "nr": "10.3.a",
      "text": "Einbau von Einrichtungen zur Nachregulierungs- und Anhaltegenauigkeit nach EN81-20: 5.12.1.1.4"
    },
    {
      "nr": "10.4.a",
      "text": "a) Einbau einer Inspektionssteuerung nach EN81-20: 5.4.9 a), und"
    },
    {
      "nr": "10.4.b",
      "text": "b) Einbau einer Bremseinrichtung nach EN81-20: 5.4.8 b)"
    },
    {
      "nr": "10.5.a",
      "text": "Einbau einer Inspektionssteuerung nach EN81-20: 5.2.1.5.1 b) in der Schachtgrube"
    },
    {
      "nr": "11.1.a",
      "text": "Bereitstellung zutreffender Hinweise, Kennzeichnungen und Betriebsanleitungen nach EN81-20: 5.2.4; 5.4.2.3.2; 5.4.2.3.3; 5.12.1.5.2.4; 5.12.1.11.1; 7.2"
    },
    {
      "nr": "11.2.a",
      "text": "Herstellen entsprechender Kennzeichnung"
    },
    {
      "nr": "11.3.a",
      "text": "Einbau eines Schalters nach EN81-20: 5.2.1.4.1"
    },
    {
      "nr": "11.4.a",
      "text": "Einbau einer Steckdose nach EN81-20: 5.10.7.2"
    },
    {
      "nr": "11.5.a",
      "text": "Erstellung und Anbringung der Kennzeichnung gem. EN81-20: 5.2.6.2.1"
    },
    {
      "nr": "11.6.a",
      "text": "Herstellen der Aufkantung gem. EN81-20: 5.2.6.7.2"
    },
    {
      "nr": "11.7.a",
      "text": "Erstellen eines Rahmens zur sicheren Lagerung der Einlagen gem. EN81-20: 5.4.11.2"
    },
    {
      "nr": "12.1.a",
      "text": "Dokumentation über den Schutz gegen Cyberangriffe an sicherheitsrelevante MSR-Einrichtungen (Mess-, Steuer- und Regeleinrichtungen) an Aufzügen."
    }
  ],
  "scProtections": [
    {
      "nr": "B0.a",
      "text": "EN 81-70: Fahrkorbabmessungen, Türbreite. Siehe Tabelle 1: Aufzug für Rollstühle mit Begleitperson (DIN EN 12183) oder elektrischer Rollstuhl der Klassen A, B, C  (DIN EN 12184)"
    },
    {
      "nr": "B1.a",
      "text": "Maßnahmen nach EN 81-70: 5.4.3, Anhang E  durchführen (akustische Signale, optische Anzeigen ≥ 40mm, kontrastreich)"
    },
    {
      "nr": "B2.a",
      "text": "Maßnahmen nach EN 81-70: 5.4.3, Anhang E durchführen (optische Anzeigen ≥ 40mm, kontrastreich)"
    },
    {
      "nr": "B3.a",
      "text": "Maßnahmen nach EN 81-70: 5.4.4.3 Absatz c durchführen (z.B. in öffentlichen Gebäuden)"
    },
    {
      "nr": "B4.a",
      "text": "Erreichbarkeit von Schlüsselschaltern u.ä. sicherstellen. Sicherstellen, dass ein Einschluss ausgeschlossen ist."
    },
    {
      "nr": "C0.a",
      "text": "Einhaltung der EN 81-70: Tabelle 2, ggf. Berücksichtigung Anhang F und G."
    },
    {
      "nr": "C1.a",
      "text": "Einhaltung der EN 81-70: Tabelle 2, ggf. Berücksichtigung Anhang G."
    },
    {
      "nr": "D0.a",
      "text": "Maßnahmen bei z.B. Glasschacht, Außenanlage treffen."
    },
    {
      "nr": "E0.a",
      "text": "EN 81-70: 5.2.2 Hindernisfreier Zugang zu Haltestellen sicherstellen"
    },
    {
      "nr": "F0.a",
      "text": "Arbeitsstättenschutzgesetz (keine Hindernisse im Zugang zu Betriebsräumen)"
    },
    {
      "nr": "F1.a",
      "text": "EN 81-20: 5.2.5.7 und 5.2.5.8"
    },
    {
      "nr": "F2.a",
      "text": "Arbeitsstättenschutzgesetz"
    },
    {
      "nr": "G0.a",
      "text": "Arbeitsstättenschutzgesetz (z.B. Gefahrstoffe), Überwachungskontakte usw."
    },
    {
      "nr": "G1.a",
      "text": "Arbeitsstättenschutzgesetz"
    },
    {
      "nr": "G2.a",
      "text": "Tragfähigkeitsangabe im Beladebereich bei Lastenaufzügen vorhanden? Piktogramme?"
    },
    {
      "nr": "G3.a",
      "text": "Kennzeichnung gem. Gefahrstoffverordnung anbringen"
    },
    {
      "nr": "G4.a",
      "text": "Maßnahmen nach EN 81-70: 5.4.3.4 durchführen"
    },
    {
      "nr": "G5.a",
      "text": "Maßnahmen nach BetrSichV durchführen in Verbindung mit EN 81-28"
    },
    {
      "nr": "G6.a",
      "text": ""
    }
  ]
}`;
    }
  },
}
</script>

<style scoped>

.width200 {
  min-width: 200px;
  max-width: 200px;
  width: 200px;
}

.horizontal {
  display: flex;
  flex-direction: row;
  background-color: transparent;
}

.error-border {
  border: 1px solid #ff4081;
}
.border {
  border: 1px solid lightgrey;
}

</style>